import { StyleSheet } from 'react-native';

export const cartStyles = StyleSheet.create({
  buttonWrapper: {
    position: 'fixed',
    flex: 1,
    flexDirection: 'row',
    top: 560,
    zIndex: 999,
    left: 30,
  },

  btnContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },

  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    backgroundColor: 'black',
    padding: 10,
    borderRadius: 20,
    marginTop: 44,
    width: 300,
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: 17,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  totalText: {
    color: '#32de84',
    fontWeight: 'bold',
  },
});
